import React from 'react';
import { FormattedMessage } from "react-intl";
import './Eingabe.css';

class EingabeKulissenbreite extends React.Component {
    constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    }

  handleChange(event) {
        this.props.SelectedKulissenbreite(event.target.value);
  }

  render() {
    return (
        <div>
          <label>
              <FormattedMessage id='Kulissenbreite' /> [mm]</label>
              <select value={this.props.value} onChange={this.handleChange}>
                  <option key={1} value={100}>{100}</option>
                  {/*<option key={2} value={150}>{150}</option>*/}
                  <option key={3} value={200}>{200}</option>
                  <option key={4} value={230}>{230}</option>
                  <option key={5} value={300}>{300}</option>
                  {/*<option key={6} value={350}>{350}</option>*/}

              </select>
        </div>
    );
  }
}
export default EingabeKulissenbreite;
